'use client';

import { ReactNode, useEffect } from 'react';
import { NextIntlClientProvider } from "next-intl";
import { SessionProvider } from "next-auth/react";
import { CartProvider } from "@/components/cart";
import ScrollToTopButton from '@/components/home-page/TopButton';
import Letstalk from '@/components/talkForm/talkFix';

interface ClientLayoutProps {
  locale: string;
  messages: any;
  children: ReactNode;
}

export default function ClientLayout({ locale, messages, children }: ClientLayoutProps) {
  useEffect(() => {
    // The environment must match both the client token and the price ID.
    // Treat any value other than an explicit sandbox value as production so
    // a typo such as "productions" cannot silently select the wrong API.
    const environment =
      process.env.NEXT_PUBLIC_PADDLE_ENVIRONMENT?.toLowerCase() === "sandbox"
        ? "sandbox"
        : "production";
    const token = process.env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN;

    const initPaddle = () => {
      if (!window.Paddle || !token) return;

      window.Paddle.Environment.set(environment);
      window.Paddle.Initialize({ token });
    };

    if (window.Paddle) {
      initPaddle();
      return;
    }

    const script = document.querySelector('script[src*="paddle"]');
    script?.addEventListener("load", initPaddle, { once: true });

    return () => script?.removeEventListener("load", initPaddle);
  }, []);
  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      <SessionProvider 
      refetchOnWindowFocus={false}  
      refetchInterval={0}          
      basePath="/api/auth">
        <CartProvider>
         <Letstalk/>
         
          {children}
        
        </CartProvider>
      </SessionProvider>
    </NextIntlClientProvider>
  );
}